import { combineReducers } from "redux";
import { AuthReducer  } from "./modules/index.js";

export default combineReducers({
  auth: AuthReducer.reducer
});

